import { OpenableCard } from '@hg/stylizator/components'
import { Text } from '@hg/stylizator/typography'
import * as React from 'react'

export interface IAttributes {
  title: string
  content: string
}

export interface IProps {
  opened: boolean
  onToggle: () => void
  className?: string
}

const OpenableCardComponent: React.FC<IAttributes & IProps> = (props) => {
  return (
    <OpenableCard className={props.className} title={props.title} onToggle={props.onToggle} opened={props.opened}>
      <Text type="body">
        <div dangerouslySetInnerHTML={{ __html: props.content }} />
      </Text>
    </OpenableCard>
  )
}

export default React.memo(OpenableCardComponent)
